







import { Component, Vue } from 'vue-property-decorator';

@Component
export default class LinkToFakturabank extends Vue {
  private fakturabankUrl = process.env.VUE_APP_FAKTURABANK_HTTP;
}
